export const globalErrorHandler = (event: ErrorEvent) => {
    if (!(event.error instanceof Error)) {
        return;
    }
    /**
     * Addreses this error: https://zillow.datadoghq.com/rum/error-tracking?issueId=872574e2-1dfc-11ef-b074-da7ad0900002
     */
    if (event.error.message === 'V') {
        event.stopPropagation();
        return;
    }
};
